export class Notification {
  public style: { icon: string; iconColor: string } = {
    icon: 'notification_info',
    iconColor: 'var(--accent-info)',
  };
  public status?: string;

  constructor(
    public id: number,
    public type: NotificationType,
    public title: string | number,
    public message: string,
    public timeoutMs: number,
  ) {}
}

export enum NotificationType {
  success = 0,
  warning = 1,
  error = 2,
  info = 3,
  consent = 4,
  token = 5,
}
